<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-input
              class="search"
              placeholder="按主题、主办方搜索"
              type="text"
              v-model.trim="keywords"
              width="10%"
            >
            </el-input>
            <el-button
              @click="onSearch"
              class="btn-search"
              type="primary"
            >搜索</el-button>
            <el-button
              @click="onDelete"
              class="btn-search"
              type="danger"
            >删除</el-button>
            <el-tab-pane
              label="待推荐"
              name="0"
            >
             <el-table :data="awaitRecommend" style="width:100%; margin-bottom: 20px;" border>
               <el-table-column
                prop="head_images"
                label="会议头图"
                width="180"
                fixed
              >
                <template slot-scope="scope" >
                  <img :src="scope.row.head_images == null ? '未上传' : scope.row.head_images" width="250px">
                </template>
              </el-table-column>
              <el-table-column
                prop="enterprise_name"
                label="主办方"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                prop="title"
                label="会议主题"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                label="会议类型"
                width="150"
                prop="type"
              >
              </el-table-column>
              <el-table-column
                prop="begin_start_time"
                label="开始时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="begin_end_time"
                label="结束时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="registrationnum"
                label="报名人数"
                width="150"
              ></el-table-column>
              <!-- 新增 -->
              <el-table-column
                prop="statusmark"
                label="会议状态"
                width="170"
              ></el-table-column>
              <el-table-column
                prop="states"
                label="是否推荐"
                width="150"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.states" placeholder="请选择" size="mini" @change="recommend(scope.row)">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
             </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeOne"
                  :current-page="currentPage.one"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalOne"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="会议频道管理"
              name="1"
            >
              <el-table :data="recommendList" style="width:100%; margin-bottom: 20px;" border>
               <el-table-column
                prop="head_images"
                label="会议头图"
                width="180"
                fixed
              >
                <template slot-scope="scope" >
                  <img :src="scope.row.head_images == null ? '未上传' : scope.row.head_images" width="250px">
                </template>
              </el-table-column>
              <el-table-column
                prop="enterprise_name"
                label="主办方"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                prop="title"
                label="会议主题"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                label="会议类型"
                width="150"
                prop="type"
              >
              </el-table-column>
              <el-table-column
                prop="begin_start_time"
                label="开始时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="begin_end_time"
                label="结束时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="registrationnum"
                label="报名人数"
                width="150"
              ></el-table-column>
              <!-- 新增 -->
              <el-table-column
                prop="statusmark"
                label="会议状态"
                width="170"
              ></el-table-column>
              <el-table-column
                prop="states"
                label="是否推荐"
                width="150"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.states" placeholder="请选择" size="mini" @change="recommend(scope.row)">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
             </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeTwo"
                  :current-page="currentPage.two"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalTwo"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="不推荐的会议"
              name="2"
            >
              <el-table :data="unRecommend" style="width:100%; margin-bottom: 20px;" border>
               <el-table-column
                prop="head_images"
                label="会议头图"
                width="180"
                fixed
              >
                <template slot-scope="scope" >
                  <img :src="scope.row.head_images == null ? '未上传' : scope.row.head_images" width="250px">
                </template>
              </el-table-column>
              <el-table-column
                prop="enterprise_name"
                label="主办方"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                prop="title"
                label="会议主题"
                width="200"
                fixed
              ></el-table-column>
              <el-table-column
                label="会议类型"
                width="150"
                prop="type"
              >
              </el-table-column>
              <el-table-column
                prop="begin_start_time"
                label="开始时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="begin_end_time"
                label="结束时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="registrationnum"
                label="报名人数"
                width="150"
              ></el-table-column>
              <!-- 新增 -->
              <el-table-column
                prop="statusmark"
                label="会议状态"
                width="170"
              ></el-table-column>
              <el-table-column
                prop="states"
                label="是否推荐"
                width="150"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.states" placeholder="请选择" size="mini" @change="recommend(scope.row)">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
             </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeThree"
                  :current-page="currentPage.three"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalThree"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
import Meeting from '../../widgets/widghtMeeting'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox,
    Meeting
  },
  data () {
    return {
      filterKeyWord: '',
      historyList: [], // 作为一个数据变量接收搜索历史记录
      uncomfirmList: [],
      comfirmList: [],
      activeName: '0',
      currentPage: {
        one: 0,
        two: 0,
        three: 0
      },
      totalOne: 0,
      totalTwo: 0,
      totalThree: 0,
      pageSize: 10,
      enterprise_account_id: 1,
      loading: false,
      centerDialogVisible: false,
      isDisabled: false,
      timeoutKeyWord: null,
      unRecommend: [],
      recommendList: [],
      awaitRecommend: [],
      keywords: '',
      options: [
        {value: 0,
          label: '待推荐'
        },
        {value: 1,
          label: '推荐'
        },
        {value: 2,
          label: '不推荐'
        }
      ]
    }
  },
  // watch: {
  //   // 函数节流
  //   q () {
  //     if (!this.timer) {
  //       this.timer = setTimeout(async () => {
  //         this.timer = null
  //         if (!this.q) {
  //           this.suggestionList = []
  //           return
  //         }
  //         const data = await getSuggestion({ q: this.q })
  //         this.suggestionList = data.options
  //       }, 500)
  //     }
  //   }
  // },
  methods: {
    // 搜索回车/虚拟操作键盘搜索
    onSearch () {
      // clearTimeout(this.timeoutKeyWord)
      // this.keywords = e
      this.timeoutKeyWord = setTimeout(() => {
        this.fetchData()
      }, 500)
    },
    // 删除搜索内容
    onDelete () {
      this.keywords = ''
      this.fetchData()
    },
    // tab切换
    handleClick (tab, event) {
      console.log(this.activeName)
      this.fetchData(this.activeName)
      console.log(tab, event)
    },
    // 是否推荐
    recommend (scope) {
      let url = this.$config.API.meeting.recommend
      let data = {
        enterprisemeeting_id: scope.id,
        isrecommend: scope.states
      }
      axios.post(url, data
      ).then(res => {
        this.$message.success('修改成功')
        this.fetchData(this.activeName)
      })
    },
    // 获取列表数据
    fetchData (activeName) {
      let url = this.$config.API.meeting.list
      this.loading = true
      const pageObj = {
        '0': this.currentPage.one,
        '1': this.currentPage.two,
        '2': this.currentPage.three
      }
      let data = {
        page: Number(pageObj[this.activeName]),
        type: Number(this.activeName),
        keywords: this.keywords
        // keywords: encodeURIComponent(this.keywords)
        //   // keywords: encodeURI((encodeURI(this.keywords)))
      }
      axios.post(url, data).then(res => {
        if (this.activeName === '0') {
          this.awaitRecommend = res.data.data.list
          this.totalOne = res.data.data.total
          this.loading = false
        } else if (this.activeName === '1') {
          this.recommendList = res.data.data.list
          this.totalTwo = res.data.data.total
          this.loading = false
        } else if (this.activeName === '2') {
          this.unRecommend = res.data.data.list
          this.totalThree = res.data.data.total
          this.loading = false
        }
        console.log('0', this.awaitRecommend)
        console.log('1', this.recommend)
        console.log('1', this.unRecommend)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 页面分页
    handlePageChangeOne (page) {
      this.currentPage.one = page
      this.fetchData('0')
    },
    handlePageChangeTwo (page) {
      this.currentPage.two = page
      this.fetchData('1')
    },
    handlePageChangeThree (page) {
      this.currentPage.three = page
      this.fetchData('2')
    }
  },
  mounted () {
    this.fetchData(this.activeName)
  }
}
</script>
<style lang="scss">
// .el-input__inner {
//   width: 80% !important; 
// }
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
  .search {
    width: 80%;
    margin-bottom: 20px;
  }
  .btn-search {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// meeting.vue?92ed2682